import React, { Component, Fragment, useState } from 'react';
import { ControlLabel, FormGroup } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import ObjGeneral from '../../../containers/function';
import strings from '../../locales/';
import API from '../../../actions/common/media/api';

class Media extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: null
    }
  }

  componentDidMount() {
    var endpoint = null
    if (this.props.endpoint != null && this.props.readOnly) {
      try {
        endpoint = JSON.parse(this.props.endpoint);
        if (endpoint.length > 0) {
          this.props.getOptionsEndpoint(this.props.inputId, endpoint[0]);
          this.setState({ endpoint: endpoint[0] });
        }
      } catch (e) {
        endpoint = null;
      }
    }
  }

  /**
   * depending on the data of the media file, returns if the source is as Url or Base64
   * @param {Object} mediaData API response object containing the media file information
   * @returns object with the source of the media file
   */
  setSourceMedia(mediaData) {
    let source = '';
    let isHttp = true;
    let dataType;

    if (mediaData.type == 'Image' || mediaData.type == 'Gif') {
      dataType = 'data:image';
    } else if (mediaData.type == 'Video') {
      dataType = 'data:video';
    }

    isHttp = mediaData.media.startsWith('http');
    source = (isHttp) ? mediaData.media : `${dataType}/${mediaData.extension};base64,${mediaData.media}`;

    return {
      source,
      isHttp
    };
  }

  render() {
    let readOnly = null;
    let sourceMedia = {};

    if (this.props.loading) {
      readOnly = (
        <p className="formOnlyReadData yellow">{strings.tasks_manager.taskform['loadingMedia']}</p>
      );
    } else if (this.props.status != null && this.props.status != 200) {
      readOnly = (
        <p className="formOnlyReadData red">{strings.tasks_manager.taskform['loadingMediaError']}</p>
      );
    } else if (this.props.readOnly && this.props.mediaData) {
      if (this.props.mediaData.type == 'Image' || this.props.mediaData.type == 'Gif') {
        sourceMedia = this.setSourceMedia(this.props.mediaData);

        readOnly = (
          <div className="mediaData">
            {
              (this.props.mediaData.disclaimer) && (
                <div className="media__disclaimer" dangerouslySetInnerHTML={{__html: this.props.mediaData.disclaimer}} />
              )
            }
            <img src={sourceMedia.source} onContextMenu={(e) => e.preventDefault()} />
            {
              this.props.mediaData.downloadable && (
                <DownloadButtonComponentPrivate
                  mediaData={this.props.mediaData}
                  sourceMedia={sourceMedia}
                  endpoint={this.state.endpoint}
                  language={this.props.language}
                />
              )
            }
          </div>
        );
      } else if (this.props.mediaData.type == 'Video') {
        sourceMedia = this.setSourceMedia(this.props.mediaData);

        readOnly = (
          <div className="mediaData">
            <video controls controlsList="nodownload" preload="auto" onContextMenu={(e) => e.preventDefault()}>
              <source type={`video/${this.props.mediaData.extension}`} src={sourceMedia.source} />
              {this.props.language.account.modalDriver.browserIssue}
            </video>
            {
              this.props.mediaData.downloadable && (
                <DownloadButtonComponentPrivate
                  mediaData={this.props.mediaData}
                  sourceMedia={sourceMedia}
                  endpoint={this.state.endpoint}
                  language={this.props.language}
                />
              )
            }
          </div>
        );
      } else if (!this.props.mediaData.type && this.props.mediaData.disclaimer) {
        readOnly = (
          <div className="mediaData">
            <div className="media__disclaimer" dangerouslySetInnerHTML={{__html: this.props.mediaData.disclaimer}} />
          </div>
        );
      }
    } else {
      readOnly = null;
    }

    if (readOnly != null)
      return (
        <div id={this.props.id} className={this.props.className}>
          <FormGroup>
            <ControlLabel>{this.props.label}</ControlLabel>
            {readOnly}
          </FormGroup>
        </div>
      );
    return null;
  }
}

Media.propTypes = {};

export default Media;


// --------------------------------------------------------------------
// PRIVATE COMPONENTS
// --------------------------------------------------------------------
const DownloadButtonComponentPrivate = (props) => {
  const { sourceMedia, mediaData, endpoint, language } = props;
  const { extension } = mediaData;
  const [isDownloading, setIsDownloading] = useState(false);
  const [buttonIcon, setButtonIcon] = useState('fas fa-download');
  const [buttonText, setButtonText] = useState(language.tasks_manager.taskform.download);
  const [hasError, setHasError] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    setButtonIcon('fas fa-spinner fa-spin');
    setButtonText(language.tasks_manager.taskform.downloading);

    try {
      const resp = await API.data.getMediaFile({
        isHttp: sourceMedia.isHttp,
        source: (sourceMedia.isHttp) ? sourceMedia.source : endpoint,
        filename: ObjGeneral.getRandomFilename(extension),
        extension,
      });

      if (resp.status !== 200) {
        throw new Error(resp.data);
      }
    } catch (error) {
      setHasError(true);
      console.log('handleDownload-error =>', error.message);
    } finally {
      setIsDownloading(false);
      setButtonIcon('fas fa-download');
      setButtonText(language.tasks_manager.taskform.download);
    }
  }

  const handleShowErrorDownload = (showErrorDownload) => {
    setHasError(showErrorDownload);
  }

  return (
    <Fragment>
      <div className="flex flex-direction-row justify-end">
        <button type="button" className="media__download" onClick={isDownloading ? null : handleDownload}>
          <i className={`${buttonIcon} mr-1`} />{buttonText}
        </button>
      </div>
      {
        hasError && (
          <SweetAlert
            error
            closeOnClickOutside={true}
            confirmBtnCssClass="confirm-button"
            title={
              <span className="modal-title">
                <strong>
                  {language.tasks_manager.taskform.downloadErrorMediaTitle}
                </strong>
              </span>
            }
            onConfirm={() => handleShowErrorDownload(false)}
          >
            <div className="tilte-modal-box">
              {language.tasks_manager.taskform.downloadErrorMediaDescription}
            </div>
          </SweetAlert>
        )
      }
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/media.jsx